import React from 'react';
import './FeaturesSection.css';

const features = [
  {
    icon: '🔬',
    title: 'AI Disease Detection',
    desc: 'Our CNN-powered machine learning model is trained on thousands of verified crop images, delivering accurate disease classification with confidence scores in real time.',
  },
  {
    icon: '📱',
    title: 'Works on Any Device',
    desc: 'Designed for use in the field. Fully optimised for smartphones, tablets, and desktops — so farmers can get results wherever they are, with any internet connection.',
  },
  {
    icon: '💊',
    title: 'Treatment Recommendations',
    desc: 'Receive expert-backed treatment plans, pesticide guidance, and preventive measures immediately after detection — no waiting, no guesswork.',
  },
  {
    icon: '📊',
    title: 'Confidence Scoring',
    desc: 'Every diagnosis includes a confidence percentage, giving you a clear picture of how certain the model is and helping you decide the right next step.',
  },
  {
    icon: '🌽',
    title: 'Tomato & Maize Specialist',
    desc: 'Purpose-built models for tomato and maize — the two most economically vital crops in South Asian agriculture — ensuring the highest possible accuracy.',
  },
  {
    icon: '📚',
    title: 'Agricultural Knowledge Base',
    desc: 'Browse a growing library of disease guides, prevention articles, and modern farming techniques written by agricultural experts and researchers.',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features">
      <div className="container">
        <div className="text-center mb-5 reveal">
          <span className="section-label">Why CropGuard AI</span>
          <h2 className="section-title mx-auto">
            Everything You Need for<br />
            <span className="accent">Smarter Crop Health</span>
          </h2>
          <p className="section-desc mx-auto">
            One platform to monitor, detect, and manage crop diseases — built for the realities
            of farming in South Asia.
          </p>
        </div>
        <div className="row g-4">
          {features.map((f, i) => (
            <div className="col-md-6 col-lg-4 reveal" key={i}>
              <div className="feat-card">
                <div className="feat-icon">{f.icon}</div>
                <div className="feat-title">{f.title}</div>
                <div className="feat-desc">{f.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
